export default "__VITE_ASSET__CG8jn$fN__"